import { render, staticRenderFns } from "./FlexTable.vue?vue&type=template&id=5cc7f73d&scoped=true&"
import script from "./FlexTable.vue?vue&type=script&lang=js&"
export * from "./FlexTable.vue?vue&type=script&lang=js&"
import style0 from "./FlexTable.vue?vue&type=style&index=0&id=5cc7f73d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cc7f73d",
  null
  
)

export default component.exports